<template>
  <div class="leave" id="leave-button">
    <v-btn
      prepend-icon="msf:call_end"
      stacked
      :rounded="8"
      size="x-small"
      variant="flat"
      color="#D83737"
      @click="stopCallHandler"
    >
      {{ $t('meeting.leave') }}
    </v-btn>
  </div>
</template>
<script setup>
import {useDestroy} from '@/procedures/useDestroy'
import {useUserStore} from '@/stores'
import {useScreenShareStore} from '@/stores/screenshareStore'
import {jsonRpc} from '@communication'
import {repository} from 'communication/src/messages'

const user = useUserStore()
const screenShareStore = useScreenShareStore()
const EXIT_LOCATION_TIMEOUT = 5000
function stopCallHandler(event) {
  event.stopPropagation()
  const isScreenSharing = screenShareStore.isScreenSharing
  if (isScreenSharing) {
    screenShareStore.stop()
  }
  if (user.isAssistant) {
    // The location only feeds the exit summary. destroy() (con:disjoin, ends the session for the others)
    // runs exactly once: on the reply, whatever its shape, or after EXIT_LOCATION_TIMEOUT without one
    let ended = false
    let locationTimer = null
    const end = () => {
      if (ended) return
      ended = true
      clearTimeout(locationTimer)
      useDestroy().destroy()
    }
    locationTimer = setTimeout(end, EXIT_LOCATION_TIMEOUT)
    jsonRpc.send(repository.fetchEventsMessage('location'), (error, response) => {
      try {
        if (!error && !ended) {
          const raw = typeof response?.value === 'string' ? response.value : response
          const events = typeof raw === 'string' ? JSON.parse(raw) : raw
          const filtered = Array.isArray(events) ? events.filter(item => item?.party === 'client') : []
          if (filtered.length) {
            const {latitude, longitude, source} = filtered[0].location ?? {}
            const coords = [latitude, longitude]
            if (coords.every(value => typeof value === 'number')) {
              exit.setLocation(coords, source)
            }
          }
        }
      } catch (locationError) {
        console.warn('Client location for the exit summary is not available', locationError)
      }
      end()
    })
  } else {
    useDestroy().destroy()
  }
}
</script>
<style lang="scss" scoped>
.leave {
  pointer-events: auto;
  .v-btn {
    font-size: 12px;
    padding: 4px 8px 4px 8px;
    gap: 0px;
    height: 52px;
    width: 68px;
  }
}
</style>
